import React from "react";
import { styled } from "@mui/system";
import { Autocomplete } from "@mui/material";
import { StyledTextField } from "../UI/StyledTextField";

// Styled wrapper for the Autocomplete component to handle error styling
const StyledAutocompleteWrapper = styled((props) => {
  const { error, ...other } = props;

  return (
    <Autocomplete
      {...other}
      renderInput={(params) => (
        <StyledTextField
          {...params}
          error={error} // Pass the error prop to StyledTextField
          label={props.column.headerName}
          fullWidth={props.fullWidth}
          margin={props.margin}
        />
      )}
    />
  );
})(({ error }) => ({
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: error ? "#E0E3E7" : "#E0E3E7",
    },
    "&:hover fieldset": {
      borderColor: error ? "#B2BAC2" : "#B2BAC2",
    },
    "&.Mui-focused fieldset": {
      borderColor: error ? "#6F7E8C" : "#6F7E8C",
    },
  },
}));

const Dropdown = ({ column, options, value, onChange, fullWidth, margin, disabled, error }) => {
  const getOptionLabel = (option) => option.name || "";
  const findOptionById = (id) =>
    options.find((option) => option.id === id) || null;

  return (
    <StyledAutocompleteWrapper
      disableClearable
      disabled={disabled}
      options={options}
      value={findOptionById(value)}
      getOptionLabel={getOptionLabel}
      onChange={(event, newValue) =>
        onChange({ target: { value: newValue.id } })
      }
      error={error}
      column={column}
      fullWidth={fullWidth}
      margin={margin}
    />
  );
};

export default Dropdown;
